module.exports = __webpack_public_path__ + "img/AvatarDiamond.36b51720.svg";